import { render, staticRenderFns } from "./report_unplanned_hos.vue?vue&type=template&id=032ef4d6&"
import script from "./report_unplanned_hos.vue?vue&type=script&lang=js&"
export * from "./report_unplanned_hos.vue?vue&type=script&lang=js&"
import style0 from "./report_unplanned_hos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports